import { ClinicLocation } from '../clinic-location';

export class ReferringDoctor {
  public id: number;
  public address: string;
  public city: string;
  public company: string;
  public email: string;
  public first_name: string;
  public last_name: string;
  public has_password: boolean;
  public state: string;
  public telephone: string;
  public zipcode: string;
  public clinic: ClinicLocation;

  constructor(data: any = {}) {
    this.id = data.id || null;
    this.address = data.address || null;
    this.city = data.city || null;
    this.company = data.company || null;
    this.email = data.email || null;
    this.first_name = data.first_name || null;
    this.last_name = data.last_name || null;
    this.has_password = data.has_password || false;
    this.state = data.state || null;
    this.telephone = data.telephone || null;
    this.zipcode = data.zipcode || null;
    this.clinic = (data.clinic && new ClinicLocation(data.clinic)) || null;
  }

  public get fullName() {
    return `${this.first_name} ${this.last_name}`;
  }
}
